/**
 * 광고 캠페인 ↔ 채널 매핑 변경 알림 계약 (단일 상수 소스) [C-4]
 *
 * 매핑 추가/교체/그룹삭제가 **서버 성공 이후에만** 이 채널로 신호를 발행하고,
 * 사이드바 미매핑 배지 훅(useUnmappedCampaignCount)이 이를 구독해
 * 다음 폴링을 기다리지 않고 즉시 count 를 재조회한다.
 *
 * ⚠️ 채널명은 여기 한 곳에만 정의한다 (발행처·구독처 문자열 불일치 방지).
 */
export const AD_MAPPING_CHANNEL = 'ad-campaign-mapping';

export interface AdMappingRefreshMessage {
  type: 'refresh';
  at: number;
}

/**
 * 매핑 변경 성공 후 모든 탭에 즉시 재조회 신호를 발행한다.
 * BroadcastChannel 미지원 환경에서는 조용히 무시(다음 폴링 주기에 반영).
 */
export function broadcastAdMappingChanged(): void {
  try {
    if (typeof BroadcastChannel !== 'undefined') {
      const bc = new BroadcastChannel(AD_MAPPING_CHANNEL);
      const message: AdMappingRefreshMessage = { type: 'refresh', at: Date.now() };
      bc.postMessage(message);
      bc.close();
    }
  } catch {
    /* unsupported — 폴링으로 대체 */
  }
}
